export default __webpack_public_path__ + "static/media/img3.5f1bab0b.jpg";